// react
import React from "react"
// material-ui
import Checkbox from "material-ui/Checkbox"
// app
import SelectField, { Style } from "containers/SelectField"
import DatePicker from "components/common/DatePicker"
import TextField from "components/common/TextField"


export default ({
    onLicenseChange,
    onAuthorityChange,
    onValidChange,
    onEplevelChange,
    onUnlimitedCheck,
    unlimited
}) => 
    <div className="clearfix">
        <h4>Add License</h4>
        <div className="float-left">
            <SelectField
                table="license"
                label="License"
                mandatory={ true }
                style={ Style.CodeOnly }
                onChange={ onLicenseChange }
            />
            <br />
            <DatePicker
                label="Valid Until"
                onChange={ onValidChange }
                disabled={ unlimited === true }
            />
            <SelectField
                table="eplevel"
                label="English Proficiency Level"
                style={ Style.CodeOnly }
                onChange={ onEplevelChange }
            />
        </div>
        <div className="float-right">
            <TextField
                label="Issuing Authority"
                mandatory={ true }
                onChange={ onAuthorityChange }
            />
            <br />
            <Checkbox
                label="Unlimited Validity"
                style={{ height: 30, paddingTop: 42 }}
                checked={ unlimited === true }
                onCheck={ onUnlimitedCheck }
            />
        </div>
    </div>


/** WEBPACK FOOTER **
 ** ./src/components/person/Licenses/add.js
 **/